import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cache-management kn-page" }
const _hoisted_2 = { class: "p-d-flex p-flex-wrap kn-page-content" }
const _hoisted_3 = { class: "p-col-4 p-sm-12 p-md-4 p-p-0" }
const _hoisted_4 = { class: "p-col-8 p-sm-12 p-md-8 p-p-0" }
const _hoisted_5 = { class: "p-col-12 p-sm-12 p-p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_RuntimeInformationCard = _resolveComponent("RuntimeInformationCard")
  const _component_GeneralSettingsCard = _resolveComponent("GeneralSettingsCard")
  const _component_DatasetTableCard = _resolveComponent("DatasetTableCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.cacheManagement.title')), 1)
      ]),
      _: 1
    }),
    (_ctx.showProgressBar)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar",
          "data-test": "progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.selectedDatasource)
          ? (_openBlock(), _createBlock(_component_RuntimeInformationCard, {
              key: 0,
              item: _ctx.cache,
              chartData: _ctx.chartData,
              onRefresh: _ctx.onRefresh
            }, null, 8, ["item", "chartData", "onRefresh"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.settingsPendingCount == 0)
          ? (_openBlock(), _createBlock(_component_GeneralSettingsCard, {
              key: 0,
              item: _ctx.settings,
              datasources: _ctx.datasources,
              selectedDatasource: _ctx.selectedDatasource,
              onInserted: _ctx.pageReload
            }, null, 8, ["item", "datasources", "selectedDatasource", "onInserted"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_DatasetTableCard, {
          datasetMetadataList: _ctx.datasetMetadataList,
          loading: _ctx.datasetMetadataLoading,
          onDeleted: _ctx.loadDatasetsMetadata
        }, null, 8, ["datasetMetadataList", "loading", "onDeleted"])
      ])
    ])
  ]))
}